
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-12 border-t border-white/5 bg-[#000000]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <span className="text-sm font-bold tracking-tighter uppercase">BloomHive</span>
            <span className="w-1 h-1 rounded-full bg-zinc-800" />
            <span className="text-[10px] text-zinc-600 uppercase tracking-[0.2em] font-medium">Engineering Lab</span>
          </div>
          
          <div className="flex gap-8">
            <a 
              href="https://github.com/BloomHive-Team" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 hover:text-white transition-colors"
            >
              GitHub
            </a>
          </div>
          
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-700 font-medium">
            &copy; {currentYear} BloomHive Collective. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
